function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M6.75 5.25C6.75 6.08 6.08 6.75 5.25 6.75C4.42 6.75 3.75 6.08 3.75 5.25C3.75 4.42 4.42 3.75 5.25 3.75C6.08 3.75 6.75 4.42 6.75 5.25Z",
  id: "bFnh0ZiNu"
}), React.createElement("path", {
  d: "M6.75 9C6.75 9.83 6.08 10.5 5.25 10.5C4.42 10.5 3.75 9.83 3.75 9C3.75 8.17 4.42 7.5 5.25 7.5C6.08 7.5 6.75 8.17 6.75 9Z",
  id: "bxYrvqsd7"
}), React.createElement("path", {
  d: "M6.75 12.75C6.75 13.58 6.08 14.25 5.25 14.25C4.42 14.25 3.75 13.58 3.75 12.75C3.75 11.92 4.42 11.25 5.25 11.25C6.08 11.25 6.75 11.92 6.75 12.75Z",
  id: "dfbCOE7qx"
}), React.createElement("path", {
  d: "M6.75 16.5C6.75 17.33 6.08 18 5.25 18C4.42 18 3.75 17.33 3.75 16.5C3.75 15.67 4.42 15 5.25 15C6.08 15 6.75 15.67 6.75 16.5Z",
  id: "b3DHJXHpgc"
}), React.createElement("path", {
  d: "M6.75 20.25C6.75 21.08 6.08 21.75 5.25 21.75C4.42 21.75 3.75 21.08 3.75 20.25C3.75 19.42 4.42 18.75 5.25 18.75C6.08 18.75 6.75 19.42 6.75 20.25Z",
  id: "a19xx8gHDl"
}), React.createElement("path", {
  d: "M6.75 24C6.75 24.83 6.08 25.5 5.25 25.5C4.42 25.5 3.75 24.83 3.75 24C3.75 23.17 4.42 22.5 5.25 22.5C6.08 22.5 6.75 23.17 6.75 24Z",
  id: "a28m9scTVh"
}), React.createElement("path", {
  d: "M6.75 27.75C6.75 28.58 6.08 29.25 5.25 29.25C4.42 29.25 3.75 28.58 3.75 27.75C3.75 26.92 4.42 26.25 5.25 26.25C6.08 26.25 6.75 26.92 6.75 27.75Z",
  id: "e2fpAJbA9d"
}), React.createElement("path", {
  d: "M6.75 31.5C6.75 32.33 6.08 33 5.25 33C4.42 33 3.75 32.33 3.75 31.5C3.75 30.67 4.42 30 5.25 30C6.08 30 6.75 30.67 6.75 31.5Z",
  id: "bviwD8nIl"
}), React.createElement("path", {
  d: "M6.75 35.25C6.75 36.08 6.08 36.75 5.25 36.75C4.42 36.75 3.75 36.08 3.75 35.25C3.75 34.42 4.42 33.75 5.25 33.75C6.08 33.75 6.75 34.42 6.75 35.25Z",
  id: "a5KJWn5aQI"
}), React.createElement("path", {
  d: "M6.75 39C6.75 39.83 6.08 40.5 5.25 40.5C4.42 40.5 3.75 39.83 3.75 39C3.75 38.17 4.42 37.5 5.25 37.5C6.08 37.5 6.75 38.17 6.75 39Z",
  id: "b3qeDK2FPi"
}), React.createElement("path", {
  d: "M6.75 42.75C6.75 43.58 6.08 44.25 5.25 44.25C4.42 44.25 3.75 43.58 3.75 42.75C3.75 41.92 4.42 41.25 5.25 41.25C6.08 41.25 6.75 41.92 6.75 42.75Z",
  id: "a31j10dt1s"
}), React.createElement("path", {
  d: "M9.25 45.25C9.25 46.08 8.58 46.75 7.75 46.75C6.92 46.75 6.25 46.08 6.25 45.25C6.25 44.42 6.92 43.75 7.75 43.75C8.58 43.75 9.25 44.42 9.25 45.25Z",
  id: "e3nBHUS8KL"
}), React.createElement("path", {
  d: "M11.76 47.75C11.76 48.57 11.08 49.25 10.26 49.25C9.43 49.25 8.75 48.57 8.75 47.75C8.75 46.92 9.43 46.25 10.26 46.25C11.08 46.25 11.76 46.92 11.76 47.75Z",
  id: "kghptxUiM"
}), React.createElement("path", {
  d: "M10.5 5.25C10.5 6.08 9.83 6.75 9 6.75C8.17 6.75 7.5 6.08 7.5 5.25C7.5 4.42 8.17 3.75 9 3.75C9.83 3.75 10.5 4.42 10.5 5.25Z",
  id: "i4gauXDdGr"
}), React.createElement("path", {
  d: "M14.25 5.25C14.25 6.08 13.58 6.75 12.75 6.75C11.92 6.75 11.25 6.08 11.25 5.25C11.25 4.42 11.92 3.75 12.75 3.75C13.58 3.75 14.25 4.42 14.25 5.25Z",
  id: "e2DbMPH6bY"
}), React.createElement("path", {
  d: "M18 5.25C18 6.08 17.33 6.75 16.5 6.75C15.67 6.75 15 6.08 15 5.25C15 4.42 15.67 3.75 16.5 3.75C17.33 3.75 18 4.42 18 5.25Z",
  id: "g4v6xkptX"
}), React.createElement("path", {
  d: "M21.75 5.25C21.75 6.08 21.08 6.75 20.25 6.75C19.42 6.75 18.75 6.08 18.75 5.25C18.75 4.42 19.42 3.75 20.25 3.75C21.08 3.75 21.75 4.42 21.75 5.25Z",
  id: "g1pZ1swyax"
}), React.createElement("path", {
  d: "M25.5 5.25C25.5 6.08 24.83 6.75 24 6.75C23.17 6.75 22.5 6.08 22.5 5.25C22.5 4.42 23.17 3.75 24 3.75C24.83 3.75 25.5 4.42 25.5 5.25Z",
  id: "a3p69dHV9"
}), React.createElement("path", {
  d: "M29.25 5.25C29.25 6.08 28.58 6.75 27.75 6.75C26.92 6.75 26.25 6.08 26.25 5.25C26.25 4.42 26.92 3.75 27.75 3.75C28.58 3.75 29.25 4.42 29.25 5.25Z",
  id: "claxl8ZGl"
}), React.createElement("path", {
  d: "M33 5.25C33 6.08 32.33 6.75 31.5 6.75C30.67 6.75 30 6.08 30 5.25C30 4.42 30.67 3.75 31.5 3.75C32.33 3.75 33 4.42 33 5.25Z",
  id: "byZTc6lsG"
}), React.createElement("path", {
  d: "M36.75 5.25C36.75 6.08 36.08 6.75 35.25 6.75C34.42 6.75 33.75 6.08 33.75 5.25C33.75 4.42 34.42 3.75 35.25 3.75C36.08 3.75 36.75 4.42 36.75 5.25Z",
  id: "d9AWZey5r"
}), React.createElement("path", {
  d: "M40.5 5.25C40.5 6.08 39.83 6.75 39 6.75C38.17 6.75 37.5 6.08 37.5 5.25C37.5 4.42 38.17 3.75 39 3.75C39.83 3.75 40.5 4.42 40.5 5.25Z",
  id: "f2HsQvPk5e"
}), React.createElement("path", {
  d: "M44.25 5.25C44.25 6.08 43.58 6.75 42.75 6.75C41.92 6.75 41.25 6.08 41.25 5.25C41.25 4.42 41.92 3.75 42.75 3.75C43.58 3.75 44.25 4.42 44.25 5.25Z",
  id: "c1STQR9aER"
}), React.createElement("path", {
  d: "M14.25 50.25C14.25 51.07 13.57 51.75 12.75 51.75C11.92 51.75 11.25 51.07 11.25 50.25C11.25 49.42 11.92 48.75 12.75 48.75C13.57 48.75 14.25 49.42 14.25 50.25Z",
  id: "d30RO2zX7S"
}), React.createElement("path", {
  d: "M46.75 7.75C46.75 8.58 46.08 9.25 45.25 9.25C44.42 9.25 43.75 8.58 43.75 7.75C43.75 6.92 44.42 6.25 45.25 6.25C46.08 6.25 46.75 6.92 46.75 7.75Z",
  id: "f46fAdhtbA"
}), React.createElement("path", {
  d: "M49.26 10.25C49.26 11.07 48.58 11.75 47.76 11.75C46.93 11.75 46.26 11.07 46.26 10.25C46.26 9.42 46.93 8.75 47.76 8.75C48.58 8.75 49.26 9.42 49.26 10.25Z",
  id: "c15ky2Try0"
}), React.createElement("path", {
  d: "M51.76 12.75C51.76 13.57 51.08 14.25 50.26 14.25C49.43 14.25 48.76 13.57 48.76 12.75C48.76 11.92 49.43 11.25 50.26 11.25C51.08 11.25 51.76 11.92 51.76 12.75Z",
  id: "b25DidilMD"
}), React.createElement("path", {
  d: "M16.75 52.76C16.75 53.59 16.08 54.26 15.25 54.26C14.42 54.26 13.75 53.59 13.75 52.76C13.75 51.93 14.42 51.26 15.25 51.26C16.08 51.26 16.75 51.93 16.75 52.76Z",
  id: "d1l7uS7zZc"
}), React.createElement("path", {
  d: "M19.25 50.26C19.25 51.08 18.57 51.76 17.75 51.76C16.92 51.76 16.25 51.08 16.25 50.26C16.25 49.43 16.92 48.76 17.75 48.76C18.57 48.76 19.25 49.43 19.25 50.26Z",
  id: "aGTBTncF4"
}), React.createElement("path", {
  d: "M21.74 47.76C21.74 48.59 21.07 49.26 20.24 49.26C19.41 49.26 18.74 48.59 18.74 47.76C18.74 46.93 19.41 46.26 20.24 46.26C21.07 46.26 21.74 46.93 21.74 47.76Z",
  id: "c2cgGZnww"
}), React.createElement("path", {
  d: "M24.25 45.26C24.25 46.08 23.57 46.76 22.75 46.76C21.92 46.76 21.25 46.08 21.25 45.26C21.25 44.43 21.92 43.76 22.75 43.76C23.57 43.76 24.25 44.43 24.25 45.26Z",
  id: "b2oolxdOn2"
}), React.createElement("path", {
  d: "M26.74 42.76C26.74 43.59 26.07 44.26 25.24 44.26C24.41 44.26 23.74 43.59 23.74 42.76C23.74 41.93 24.41 41.26 25.24 41.26C26.07 41.26 26.74 41.93 26.74 42.76Z",
  id: "a7jkpPgqy"
}), React.createElement("path", {
  d: "M29.25 40.25C29.25 41.08 28.57 41.76 27.75 41.76C26.92 41.76 26.25 41.08 26.25 40.25C26.25 39.43 26.92 38.75 27.75 38.75C28.57 38.75 29.25 39.43 29.25 40.25Z",
  id: "d1CuNuv8FU"
}), React.createElement("path", {
  d: "M31.74 37.76C31.74 38.59 31.07 39.26 30.24 39.26C29.41 39.26 28.74 38.59 28.74 37.76C28.74 36.93 29.41 36.26 30.24 36.26C31.07 36.26 31.74 36.93 31.74 37.76Z",
  id: "g2Jssyavim"
}), React.createElement("path", {
  d: "M34.25 35.25C34.25 36.08 33.57 36.75 32.75 36.75C31.92 36.75 31.25 36.08 31.25 35.25C31.25 34.43 31.92 33.75 32.75 33.75C33.57 33.75 34.25 34.43 34.25 35.25Z",
  id: "c13aKM1Mxs"
}), React.createElement("path", {
  d: "M36.75 32.76C36.75 33.59 36.08 34.26 35.25 34.26C34.42 34.26 33.75 33.59 33.75 32.76C33.75 31.93 34.42 31.26 35.25 31.26C36.08 31.26 36.75 31.93 36.75 32.76Z",
  id: "a1dm0nf9vM"
}), React.createElement("path", {
  d: "M39.24 30.25C39.24 31.08 38.57 31.75 37.74 31.75C36.92 31.75 36.24 31.08 36.24 30.25C36.24 29.43 36.92 28.75 37.74 28.75C38.57 28.75 39.24 29.43 39.24 30.25Z",
  id: "b1NMDqn40y"
}), React.createElement("path", {
  d: "M41.75 27.75C41.75 28.58 41.08 29.25 40.25 29.25C39.42 29.25 38.75 28.58 38.75 27.75C38.75 26.92 39.42 26.25 40.25 26.25C41.08 26.25 41.75 26.92 41.75 27.75Z",
  id: "aDU1oviNg"
}), React.createElement("path", {
  d: "M44.25 25.25C44.25 26.08 43.57 26.75 42.75 26.75C41.92 26.75 41.25 26.08 41.25 25.25C41.25 24.43 41.92 23.75 42.75 23.75C43.57 23.75 44.25 24.43 44.25 25.25Z",
  id: "dOWQPSs3h"
}), React.createElement("path", {
  d: "M46.75 22.75C46.75 23.58 46.08 24.25 45.25 24.25C44.42 24.25 43.75 23.58 43.75 22.75C43.75 21.92 44.42 21.25 45.25 21.25C46.08 21.25 46.75 21.92 46.75 22.75Z",
  id: "b1g7j67Qx4"
}), React.createElement("path", {
  d: "M49.25 20.25C49.25 21.08 48.57 21.75 47.75 21.75C46.92 21.75 46.25 21.08 46.25 20.25C46.25 19.43 46.92 18.75 47.75 18.75C48.57 18.75 49.25 19.43 49.25 20.25Z",
  id: "a8JFGtEw9"
}), React.createElement("path", {
  d: "M51.75 17.75C51.75 18.58 51.08 19.25 50.25 19.25C49.42 19.25 48.75 18.58 48.75 17.75C48.75 16.92 49.42 16.25 50.25 16.25C51.08 16.25 51.75 16.92 51.75 17.75Z",
  id: "jo5zGe79"
}), React.createElement("path", {
  d: "M54.25 15.25C54.25 16.07 53.57 16.75 52.75 16.75C51.92 16.75 51.25 16.07 51.25 15.25C51.25 14.42 51.92 13.75 52.75 13.75C53.57 13.75 54.25 14.42 54.25 15.25Z",
  id: "anLuFN28i"
}), React.createElement("path", {
  d: "M14.32 13.8L16.74 10L18.42 11.68L17.98 14.93L22.46 19.42L27.16 11.08L29.12 13.04L26.33 23.57L28.35 25.59L29.44 26.68C29.44 26.68 29.44 26.68 29.44 26.68C29.91 27.33 30.1 28.13 29.96 28.92C29.95 28.98 29.92 29.12 29.88 29.36L29.36 29.87",
  id: "k1C9SeDb5y"
}), React.createElement("path", {
  d: "M13.8 14.31L10 16.74L11.68 18.42L14.94 17.97L19.42 22.46L11.08 27.15L13.04 29.12L23.57 26.33L25.59 28.34L26.69 29.44C26.69 29.44 26.69 29.44 26.69 29.44C27.33 29.9 28.14 30.09 28.92 29.95C28.98 29.94 29.13 29.91 29.36 29.87L29.88 29.36",
  id: "fBQoKgHLq"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#bFnh0ZiNu",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#bxYrvqsd7",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#dfbCOE7qx",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#b3DHJXHpgc",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#a19xx8gHDl",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#a28m9scTVh",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#e2fpAJbA9d",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#bviwD8nIl",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#a5KJWn5aQI",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#b3qeDK2FPi",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#a31j10dt1s",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#e3nBHUS8KL",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#kghptxUiM",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#i4gauXDdGr",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#e2DbMPH6bY",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#g4v6xkptX",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#g1pZ1swyax",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#a3p69dHV9",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#claxl8ZGl",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#byZTc6lsG",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#d9AWZey5r",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#f2HsQvPk5e",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#c1STQR9aER",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#d30RO2zX7S",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#f46fAdhtbA",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#c15ky2Try0",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#b25DidilMD",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#d1l7uS7zZc",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#aGTBTncF4",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#c2cgGZnww",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#b2oolxdOn2",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#a7jkpPgqy",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#d1CuNuv8FU",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#g2Jssyavim",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#c13aKM1Mxs",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#a1dm0nf9vM",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#b1NMDqn40y",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#aDU1oviNg",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#dOWQPSs3h",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#b1g7j67Qx4",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#a8JFGtEw9",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#jo5zGe79",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#anLuFN28i",
  opacity: 1,
  fill: "#585858",
  fillOpacity: 1
})), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#k1C9SeDb5y",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#585858",
  strokeWidth: 1,
  strokeOpacity: 1
}))), React.createElement("g", null, React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#fBQoKgHLq",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#585858",
  strokeWidth: 1,
  strokeOpacity: 1
}))))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 60 60",
    width: 60,
    height: 60
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/ornament.308b2f48.svg";
export { SvgComponent as ReactComponent };